<div class="main-content">
    <div class="row">
        <div class="col-12 ">
            <mat-card style="box-shadow: none !important;">
                <mat-card-content style="padding: 15px;">
                    <div class="container mainContentNew">
                        <div class="d-flex">
                            <mat-icon  class="chat-back-button" (click)="goBack()" style="margin-right: 10px;">arrow_back</mat-icon>
                            <h4 class="text-black">CEU</h4>
                        </div>
                        <div class="d-flex justify-content-between d-none d-md-none d-lg-flex">
                            <span class="d-block" style="color: #979797; width: 70%">
                                View your CEU inquiry
                            </span>
                            <ul class="breadcrumb d-none d-sm-none d-md-none d-lg-flex">
                                <li class=""><a [routerLink]="['/dashboard/home']">Home</a></li>
                                <li class="separator">/</li>
                                <li><a style="color: #979797" [routerLink]="['/my-wallet']" [queryParams]="{tab: 'ceus'}">Wallet</a></li>
                                <li class="separator">/</li>
                                <li class="active"><a style="color: #979797" href="#">CEU</a></li>
                            </ul>
                        </div>

                        <hr style="height: 1px; background: #ccc; border: none" />
                    </div>

                    <div class="container" *ngIf="ceu && ceu.certification">
                        <div class="row">
                            <div class="col-12">
                                <b>Certification Title</b>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                {{ceu?.certification?.certificationTitle}}
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <b>Document Type</b>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                {{maskingColumn('parameterLabel', 'parameterValue', documentTypes.parameterMembers, ceu?.document?.documentType)}}
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <b>File</b>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                {{ceu?.document?.fileName}}
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <b>Activity Type</b>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                {{(activity?.activity?.activityType)? activity?.activity?.activityType : '-'}}
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <b>Validity Check</b>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                <div class="table-responsive list-wrapper-bordered">
                                    <table class="table table-striped table-hover table-borderless border-0" >
                                        <thead>
                                        <tr>
                                            <th class="text-nowrap">Condition Name</th>
                                            <th class="text-nowrap">Value If Valid</th>
                                            <th class="text-nowrap">Your Answer</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr *ngFor="let a of activity?.activity?.conditions">
                                            <td class="text-nowrap" style="color: #000;">{{a?.conditionName}}</td>
                                            <td class="text-nowrap" style="color: #000;">
                                                {{maskingColumn('parameterLabel', 'parameterValue', integerLogics.parameterMembers, a?.integerOperator)}}
                                                {{(a.conditionType == 'BOOLEAN')? ((a?.valueIfValid == 'true')? 'Yes':'No') : a?.valueIfValid}}
                                            </td>
                                            <td class="text-nowrap" style="color: #000;">
                                                {{(a.conditionType == 'BOOLEAN')? ((a?.answer == 'true')? 'Yes':'No') : a?.answer}}
                                            </td>
                                        </tr>
                                        <tr *ngIf="!activity?.activity?.conditions">
                                            <td colspan="3" class="text-center">
                                                <span>Validation response recorded</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <b>{{ activity?.activity?.completionQuestion }}</b>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                {{activity?.activity?.completionQuestionAnswer}} {{activity?.activity?.unitBase}}
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <b>Summary</b>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                {{(activity?.summary)? activity?.summary : '-'}}
                            </div>
                        </div>

                    </div>

                    <div class="container" *ngIf="ceu && !ceu.certification">
                        <div class="row">
                            <div class="col-12">
                                Loading...
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>




